import React from "react";

function Tr({ task, status, dueby, duein, actionby }) {
  return (
    <tr>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {task}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {status === "pending" && (
          <div className="w-16 border shadow-lg h-2 bg-gradient-to-r from-red-500 to-white mx-auto" />
        )}
        {status === "completed" && (
          <div className="w-16 border shadow-lg h-2 bg-gradient-to-l from-green-500 to-white mx-auto" />
        )}
        {status === "progress" && (
          <div className="w-16 border shadow-lg h-2 bg-gradient-to-l from-yellow-500 to-white mx-auto" />
        )}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {dueby}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {duein}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {actionby}
      </td>
      <td className="px-2 py-5 whitespace-nowrap text-xs font-medium text-gray-900">
        <div className="flex justify-around">
          <button className="bg-pink-500  text-white block text-xl w-7 h-7 rounded-full">
            +
          </button>
        </div>
      </td>
    </tr>
  );
}

const Table = () => {
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <div className="py-2 inline-block min-w-full">
          <div className="overflow-hidden">
            <table className="min-w-full text-center">
              <thead>
                <tr>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Task
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Status
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Due by
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Due in
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Action by
                  </th>
                  <th className="text-sm font-bold text-gray-900 px-2 py-2">
                    Task Checklist
                  </th>
                </tr>
              </thead>
              <tbody className="bg-gray-100 shadow-2xl border rounded">
                <Tr
                  task="Interview"
                  status="pending"
                  dueby="12/12/2021"
                  duein="3 Days"
                  actionby="Jamia"
                />
                <Tr
                  task="Sign Employment Contract"
                  status="completed"
                  dueby="12/12/2021"
                  duein="3 Days"
                  actionby="Jamia"
                />
                <Tr
                  task="Sign Contract"
                  status="progress"
                  dueby="12/12/2021"
                  duein="3 Days"
                  actionby="Jamia"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
